import React from "react";

export default function Logo({ className = "", width = 168 }) {
  return (
    <img
      src="/intersect-logo.webp"
      alt="Intersect Holding"
      width={width}
      className={className}
      style={{ width, height: "auto", display: "block" }}
      draggable={false}
    />
  );
}
